import { Box, FormControl, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel/TabPanel';
import { FormInput } from '@/components/FormInput';
import TvIcon from '@mui/icons-material/Tv';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button } from '@/components/Button';
import { Control, FieldErrors } from 'react-hook-form';
import { CreateAdFormData } from '@/pages/ad-pages/CreateAd';
import { Card } from '@/features/card';

export enum PaymentModel {
  PPV = 'ppv',
  PPD = 'ppd',
}

enum CalculationModel {
  Dynamic = 'dynamic',
  Fixed = 'fixed',
}

type Props = {
  control: Control<CreateAdFormData>;
  errors: FieldErrors<CreateAdFormData>;
  onModelChange: (model: PaymentModel) => void;
};

export const PaymentModelSection: FC<Props> = ({
  control,
  errors,
  onModelChange,
}) => {
  const { t } = useTranslation();
  const [paymentModel, setPaymentModel] = useState<PaymentModel>(
    PaymentModel.PPD
  );
  const [calculationModel, setCalculationModel] = useState<CalculationModel>(
    CalculationModel.Dynamic
  );

  const handleModelChange = (model: PaymentModel) => {
    onModelChange(model);
    setPaymentModel(model);
  };

  return (
    <div>
      <Typography variant="h6" sx={{ mb: '8px' }}>
        <Trans i18nKey="create_ad.payment_model.title" />
      </Typography>

      <Card>
        <div className="flex gap-4">
          <Button
            variant="contained"
            size="large"
            startIcon={<TvIcon />}
            color={paymentModel === PaymentModel.PPD ? 'secondary' : 'primary'}
            onClick={() => handleModelChange(PaymentModel.PPD)}
            disableElevation
          >
            <Trans i18nKey="create_ad.payment_model.ppd.title" />
          </Button>
          <Button
            variant="contained"
            size="large"
            startIcon={<VisibilityIcon />}
            color={paymentModel === PaymentModel.PPV ? 'secondary' : 'primary'}
            onClick={() => handleModelChange(PaymentModel.PPV)}
            disableElevation
          >
            <Trans i18nKey="create_ad.payment_model.ppv.title" />
          </Button>
        </div>

        {paymentModel && (
          <div className="w-full">
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={paymentModel}>
                <TabPanel value={PaymentModel.PPD}>
                  <div className="pb-4">
                    <div className="flex gap-4">
                      <div className="basis-3/5">
                        <FormControl sx={{ marginBottom: '1rem' }}>
                          <div className="flex gap-4">
                            <Button
                              variant="contained"
                              color={
                                calculationModel === CalculationModel.Dynamic
                                  ? 'secondary'
                                  : 'primary'
                              }
                              onClick={() =>
                                setCalculationModel(CalculationModel.Dynamic)
                              }
                            >
                              <Trans i18nKey="create_ad.payment_model.ppd.calculation_model.dynamic.title" />
                            </Button>
                            {/* <Button
                          variant="contained"
                          size="large"
                          color={
                            calculationModel === CalculationModel.Fixed
                              ? 'secondary'
                              : 'primary'
                          }
                          onClick={() =>
                            setCalculationModel(CalculationModel.Fixed)
                          }
                        >
                          <Trans i18nKey="create_ad.payment_model.ppd.calculation_model.fixed.title" />
                        </Button> */}
                          </div>
                        </FormControl>

                        {calculationModel === CalculationModel.Dynamic && (
                          <>
                            <Typography
                              variant="subtitle1"
                              sx={{ marginBottom: '0.5rem' }}
                            >
                              <Trans i18nKey="create_ad.payment_model.ppd.calculation_model.displays_to_buy.title" />
                            </Typography>
                            <FormInput
                              name="displays"
                              label={t(
                                'create_ad.payment_model.ppd.calculation_model.displays_to_buy.label'
                              )}
                              control={control}
                              error={!!errors.displays}
                              fullWidth={true}
                              helperText={
                                errors.displays?.message?.toString() || ''
                              }
                            />
                          </>
                        )}

                        {/* {calculationModel === CalculationModel.Fixed && (
                      <>
                        <Typography
                          variant="subtitle1"
                          sx={{ marginBottom: '0.5rem' }}
                        >
                          <Trans i18nKey="create_ad.payment_model.calculation_model.amount_to_pay.title" />
                        </Typography>
                        <FormInput
                          name="budget"
                          label={t(
                            'create_ad.payment_model.calculation_model.amount_to_pay.label'
                          )}
                          control={control}
                          // error={!!errors[field.name]}
                          fullWidth={true}
                          // helperText={
                          //   errors[field.name] && errors[field.name].message
                          // }
                        />
                      </>
                    )} */}
                      </div>
                      {/* <div className="basis-2/5">
                    <Alert severity="info">
                      <AlertTitle>
                        <Trans i18nKey="date_time_section.main_info_title" />
                        Explanation:
                      </AlertTitle>
                      <Trans i18nKey="create_ad.payment_model.ppd.explanation" />
                    </Alert>
                  </div> */}
                    </div>
                  </div>
                </TabPanel>

                <TabPanel value={PaymentModel.PPV}>
                  <div className="pb-4">
                    <div className="flex gap-4">
                      <div className="basis-3/5">
                        <FormControl sx={{ marginBottom: '1rem' }}>
                          <div className="flex gap-4">
                            <Button
                              variant="contained"
                              size="large"
                              color={
                                calculationModel === CalculationModel.Dynamic
                                  ? 'secondary'
                                  : 'primary'
                              }
                              onClick={() =>
                                setCalculationModel(CalculationModel.Dynamic)
                              }
                              disableElevation
                            >
                              <Trans i18nKey="create_ad.payment_model.ppv.calculation_model.dynamic.title" />
                            </Button>
                            {/* <Button
                          variant="contained"
                          size="large"
                          color={
                            calculationModel === CalculationModel.Fixed
                              ? 'secondary'
                              : 'primary'
                          }
                          onClick={() =>
                            setCalculationModel(CalculationModel.Fixed)
                          }
                        >
                          <Trans i18nKey="create_ad.payment_model.ppv.calculation_model.fixed.title" />
                        </Button> */}
                          </div>
                        </FormControl>

                        {calculationModel === CalculationModel.Dynamic && (
                          <>
                            <Typography
                              variant="subtitle1"
                              sx={{ marginBottom: '0.5rem' }}
                            >
                              <Trans i18nKey="create_ad.payment_model.ppv.calculation_model.views_to_buy.title" />
                            </Typography>
                            <FormInput
                              name="views"
                              label={t(
                                'create_ad.payment_model.ppv.calculation_model.views_to_buy.label'
                              )}
                              control={control}
                              // error={!!errors[field.name]}
                              fullWidth={true}
                              // helperText={
                              //   errors[field.name] && errors[field.name].message
                              // }
                            />
                          </>
                        )}

                        {/* {calculationModel === CalculationModel.Fixed && (
                      <>
                        <Typography
                          variant="subtitle1"
                          sx={{ marginBottom: '0.5rem' }}
                        >
                          <Trans i18nKey="create_ad.payment_model.calculation_model.amount_to_pay.title" />
                        </Typography>
                        <FormInput
                          name="budget"
                          label={t(
                            'create_ad.payment_model.calculation_model.amount_to_pay.label'
                          )}
                          control={control}
                          // error={!!errors[field.name]}
                          fullWidth={true}
                          // helperText={
                          //   errors[field.name] && errors[field.name].message
                          // }
                        />
                      </>
                    )} */}
                      </div>
                      {/* <div className="basis-2/5">
                    <Alert severity="info">
                      <AlertTitle>
                        <Trans i18nKey="date_time_section.main_info_title" />
                        Explanation:
                      </AlertTitle>
                      <Trans i18nKey="create_ad.payment_model.ppd.explanation" />
                    </Alert>
                  </div> */}
                    </div>
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        )}
      </Card>
    </div>
  );
};
